module.exports = __webpack_public_path__ + "assets/img/Employment-Inovations-Landing-Page-w540.f5f27e36.jpg";